module.exports = __webpack_public_path__ + "media/welcome_3.0196f00d.mp3";